<li class="item">
  <div class="container-title">
    <label>{{ label }}</label>
  </div>
</li>
